export default {
      id: "chevron-right-usage",
      viewBox: "0 0 320 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#chevron-right",
      toString: function () {
        return this.url;
      }
    }